import { render, staticRenderFns } from "./transaction-basic-2.vue?vue&type=template&id=de7fa02a&"
import script from "./transaction-basic-2.vue?vue&type=script&lang=js&"
export * from "./transaction-basic-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports